export const IconCandidates: {
  name: 'icon_candidates-5c2fb5e9676e'
} = {
  name: 'icon_candidates-5c2fb5e9676e'
}
